import TextEditor from './TextEditor.container';

export default TextEditor;
